export function getMvtConfig(): MvtConfig {
	return window.chatbotMvtConfig ? window.chatbotMvtConfig : {};
}

export function waitForGoogleAnalytics(
	attemptsLimit: number,
	interval = 500
): Promise<void> {
	let attemptsTotal = 0;

	return new Promise((resolve) => {
		async function check(): Promise<void> {
			if (attemptsTotal <= attemptsLimit) {
				attemptsTotal = attemptsTotal + 1;

				if (window.ga) {
					return resolve();
				}

				await new Promise((done) => {
					window.setTimeout(done, interval);
				});

				return check();
			}
			return resolve();
		}

		check();
	});
}
